import type { RouteRecordRaw } from 'vue-router'

import { ROUTES } from './route-names'

export default (): RouteRecordRaw[] => {
  return [
    {
      component: () => import('~/scopes/auth/pages/Login/Login.vue'),
      name: ROUTES.AUTH.LOGIN,
      path: '/:locale/auth/login',
      meta: {
        layout: false,
        owners: ['bot-squad-identity'],
        userLoadingStrategy: 'never',
        tracking: { contentGroup: 'Authentication' },
        shoppingAssistant: { enabled: false },
      },
    },
    {
      component: () =>
        import('~/scopes/auth/pages/ResetPassword/ResetPassword.vue'),
      name: ROUTES.AUTH.RESET_PASSWORD,
      path: '/:locale/password-reset',
      meta: {
        layout: false,
        owners: ['bot-squad-identity'],
        tracking: { contentGroup: 'Authentication' },
        shoppingAssistant: { enabled: false },
      },
    },
    {
      component: () =>
        import('~/scopes/auth/pages/ResetPasswordConfirm/ResetPasswordConfirm.vue'),
      name: ROUTES.AUTH.RESET_PASSWORD_CONFIRM,
      path: '/:locale/password-reset/confirm',
      meta: {
        layout: false,
        owners: ['bot-squad-identity'],
        tracking: { contentGroup: 'Authentication' },
        shoppingAssistant: { enabled: false },
      },
    },
    {
      component: () =>
        import('~/scopes/auth/pages/SetNewPassword/SetNewPassword.vue'),
      name: ROUTES.AUTH.SET_NEW_PASSWORD,
      path: '/:locale/password-reset/set-new/:userId/:token',
      meta: {
        owners: ['bot-squad-identity'],
        tracking: { contentGroup: 'Authentication' },
        shoppingAssistant: { enabled: false },
      },
    },
    {
      component: () =>
        import('~/scopes/auth/pages/SetNewPasswordExpired/SetNewPasswordExpired.vue'),
      name: ROUTES.AUTH.SET_NEW_PASSWORD_EXPIRED,
      path: '/:locale/password-reset/expired-reset',
      meta: {
        owners: ['bot-squad-identity'],
        tracking: { contentGroup: 'Authentication' },
        shoppingAssistant: { enabled: false },
      },
    },
    {
      component: () =>
        import('~/scopes/auth/pages/GuestUpgrade/GuestUpgrade.vue'),
      name: ROUTES.AUTH.GUEST_UPGRADE,
      path: '/:locale/guest-upgrade',
      meta: {
        auth: {
          mode: 'guest-magic-link',
          redirection: { name: ROUTES.AUTH.GUEST_UPGRADE_RESEND_LINK },
        },
        layout: 'minimal',
        owners: ['bot-squad-identity'],
        userLoadingStrategy: 'never',
        tracking: { contentGroup: 'Authentication' },
        shoppingAssistant: { enabled: false },
      },
    },
    {
      component: () =>
        import('~/scopes/auth/pages/GuestUpgradeResendLink/GuestUpgradeResendLink.vue'),
      name: ROUTES.AUTH.GUEST_UPGRADE_RESEND_LINK,
      path: '/:locale/guest-upgrade/resend-link',
      meta: {
        layout: 'minimal',
        owners: ['bot-squad-identity'],
        tracking: { contentGroup: 'Authentication' },
        shoppingAssistant: { enabled: false },
      },
    },
    {
      component: () => import('~/scopes/auth/pages/Logout/Logout.vue'),
      name: ROUTES.AUTH.LOGOUT,
      path: '/:locale/logout',
      meta: {
        layout: false,
        owners: ['bot-squad-identity'],
        tracking: { contentGroup: 'Authentication' },
        shoppingAssistant: { enabled: false },
      },
    },
  ]
}
